import { LegalPage } from "@/components/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy" updated="26 agosto 2026">
      <section>
        <h2>1. Titolare del trattamento</h2>
        <p>
          Il titolare del trattamento dei dati personali è <strong>Orologi e Preziosi</strong>, con sede in Via Diomede
          Carafa 62, 80124 Napoli (Italia), P.IVA 09891821218, raggiungibile all'indirizzo email{" "}
          <a href="mailto:carminelucariello@yahoo.it">carminelucariello@yahoo.it</a> o al numero{" "}
          <a href="tel:+393511997843">+39 351 199 7843</a>.
        </p>
      </section>
      <section>
        <h2>2. Dati che raccogliamo</h2>
        <p>Attraverso il sito raccogliamo esclusivamente i dati che ci fornisci volontariamente:</p>
        <ul>
          <li>
            <strong>Modulo di valutazione e contatto:</strong> nome, indirizzo email, numero di telefono, descrizione
            dell'orologio o del gioiello ed eventuali messaggi liberi.
          </li>
          <li>
            <strong>Contatto WhatsApp:</strong> se ci scrivi tramite il pulsante WhatsApp, la conversazione avviene
            sull'applicazione WhatsApp secondo l'informativa privacy di WhatsApp LLC.
          </li>
          <li>
            <strong>Area riservata:</strong> credenziali di accesso degli amministratori del sito (email e password
            protette), utilizzate esclusivamente per la gestione del catalogo.
          </li>
        </ul>
        <p>Non raccogliamo dati di navigazione a fini di profilazione e non utilizziamo strumenti di analytics.</p>
      </section>
      <section>
        <h2>3. Finalità e base giuridica</h2>
        <ul>
          <li>
            <strong>Rispondere alle tue richieste</strong> di valutazione, informazioni o acquisto (art. 6, par. 1,
            lett. b del GDPR — esecuzione di misure precontrattuali).
          </li>
          <li>
            <strong>Sicurezza e funzionamento tecnico del sito</strong> (art. 6, par. 1, lett. f del GDPR — legittimo
            interesse).
          </li>
        </ul>
      </section>
      <section>
        <h2>4. Conservazione e sicurezza</h2>
        <p>
          Le richieste di valutazione e contatto sono conservate per un massimo di 12 mesi, salvo tu abbia acconsentito
          a essere ricontattato. I dati sono ospitati su infrastrutture sicure e non sono mai venduti né ceduti a terzi
          per scopi commerciali.
        </p>
      </section>
      <section>
        <h2>5. I tuoi diritti</h2>
        <p>
          Ai sensi degli artt. 15-22 del GDPR puoi chiedere in qualsiasi momento accesso, rettifica, cancellazione,
          limitazione o portabilità dei tuoi dati, oppure opporti al trattamento, scrivendo a{" "}
          <a href="mailto:carminelucariello@yahoo.it">carminelucariello@yahoo.it</a>. Puoi inoltre proporre reclamo al
          Garante per la protezione dei dati personali (www.garanteprivacy.it).
        </p>
      </section>
      <section>
        <h2>6. Cookie</h2>
        <p>
          Per tutte le informazioni sui cookie utilizzati da questo sito consulta la{" "}
          <a href="/cookie-policy">Cookie Policy</a>.
        </p>
      </section>
    </LegalPage>
  );
}
